import BaseOptionsBundle from "%/dynamic-components/render-engine/classes/base-options";
import BoxShadow from "%/dynamic-components/render-engine/options/box-shadow-options/box-shadow";
import TextShadow from "%/dynamic-components/render-engine/options/text-shadow-options/text-shadow";

export default class EffectsOptions extends BaseOptionsBundle {
  optionTitle = "Effects";
  static optionClassName = "i-dynamic-effects";

  constructor(values = {}, hideFromInspector = {}) {
    super(values, [
      new BoxShadow(undefined, hideFromInspector["box-shadow"] ?? false),
      new TextShadow(undefined, hideFromInspector["text-shadow"] ?? false),
    ]);
  }
}
